import type { App } from 'vue';
import ApplicationProcessLayout from '@/layouts/application-process-layout.vue';
import UserAdminLayout from '@/layouts/user-admin-layout.vue';

export const ApplicationProcessLayoutName = 'ApplicationProcessLayout';
export const UserAdminLayoutName = 'UserAdminLayout';

export const registerLayoutComponent = (app: App) => {
    app.component(ApplicationProcessLayoutName, ApplicationProcessLayout);
    app.component(UserAdminLayoutName, UserAdminLayout);
};
